import * as React from "react";
import { useState } from "react";
import * as Immutable from "immutable";
import { KEY_PREFIX, fetchInputs } from "hooks/usePaginatedInputs";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import QueryHelper from "components/common/QueryHelper";
import CreateInputControl from "components/inputs/CreateInputControl";
import customColumnRenderers from "components/inputs/InputsOveriew/ColumnRenderers";
import getInputsTableElements from "components/inputs/InputsOveriew/Constants";
import useInputsStates from "hooks/useInputsStates";
import useTableElements from "components/inputs/InputsOveriew/useTableElements";
import { InputMetricsProvider } from "components/inputs/InputsOveriew/InputMetricsContext";
import { backendFieldsForVisibleColumns } from "components/inputs/InputsOveriew/metricColumns";
import useUserLayoutPreferences from "components/common/EntityDataTable/hooks/useUserLayoutPreferences";
import { ATTRIBUTE_STATUS } from "components/common/EntityDataTable/Constants";
import { IfPermitted } from "components/common";
const entityName = "input";
const InputsOverview = ({
  node = void 0,
  global = void 0,
  inputTypeDescriptions,
  inputTypes,
  entityTableId = void 0,
  withoutURLParams = false
}) => {
  var _a;
  const { data: inputStates } = useInputsStates();
  const { tableLayout, additionalAttributes } = getInputsTableElements();
  const resolvedTableLayout = entityTableId ? { ...tableLayout, entityTableId } : tableLayout;
  const resolvedKeyFn = (searchParams) => [
    ...KEY_PREFIX,
    entityTableId != null ? entityTableId : tableLayout.entityTableId,
    searchParams
  ];
  const { entityActions, expandedSections } = useTableElements({
    inputTypes,
    inputTypeDescriptions
  });
  const columnRenderers = customColumnRenderers({ inputTypes, inputStates });
  const fetchEntities = (options) => {
    const optionsCopy = { ...options };
    if (node) {
      optionsCopy.filters = Immutable.OrderedMap(options.filters).set("node_id", [node.node_id]);
    } else if (global) {
      optionsCopy.filters = Immutable.OrderedMap(options.filters).set("global", ["true"]);
    }
    return fetchInputs(optionsCopy);
  };
  const [visibleInputIds, setVisibleInputIds] = useState([]);
  const onDataLoaded = (data) => {
    const nextVisibleInputIds = data.list.map((entity) => entity.id);
    setVisibleInputIds((currentVisibleInputIds) => {
      const hasSameInputIds = currentVisibleInputIds.length === nextVisibleInputIds.length && currentVisibleInputIds.every((inputId, index) => inputId === nextVisibleInputIds[index]);
      return hasSameInputIds ? currentVisibleInputIds : nextVisibleInputIds;
    });
  };
  const { data: layoutPreferences } = useUserLayoutPreferences(resolvedTableLayout.entityTableId);
  const userPrefs = (_a = layoutPreferences == null ? void 0 : layoutPreferences.attributes) != null ? _a : {};
  const userSelection = Object.entries(userPrefs).filter(([, pref]) => pref.status === ATTRIBUTE_STATUS.show).map(([attributeId]) => attributeId);
  const visibleColumns = userSelection.length > 0 ? userSelection : resolvedTableLayout.defaultDisplayedAttributes;
  const requestedFields = backendFieldsForVisibleColumns(visibleColumns);
  return /* @__PURE__ */ React.createElement("div", null, !node && !global && /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "inputs:create" }, /* @__PURE__ */ React.createElement(CreateInputControl, null)), /* @__PURE__ */ React.createElement(InputMetricsProvider, { inputIds: visibleInputIds, fields: requestedFields }, /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "inputs",
      additionalAttributes,
      queryHelpComponent: /* @__PURE__ */ React.createElement(QueryHelper, { entityName }),
      entityActions,
      tableLayout: resolvedTableLayout,
      fetchEntities,
      onDataLoaded,
      expandedSectionRenderers: expandedSections,
      keyFn: resolvedKeyFn,
      bulkSelection: void 0,
      withoutURLParams,
      entityAttributesAreCamelCase: false,
      filterValueRenderers: {},
      columnRenderers
    }
  )));
};
export default InputsOverview;
